import { createSlice } from "@reduxjs/toolkit";
import { getBadgeAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getBadgeSlice = createSlice({
  name: "getBadge",
  initialState: data,
  reducers: {
    getBadgeSlice(state) {
      state.isLoading = false;
    },
    getBadgeSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    getBadgeSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    getBadgeSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const getBadgeHandler = () => async (dispatch: any) => {
  try {
    dispatch(getBadgeAction.getBadgeSlice());
    const response: any = await getBadgeAPI();
    dispatch(getBadgeAction.getBadgeSliceSuccess(response));
  } catch (e: any) {
    dispatch(getBadgeAction.getBadgeSliceFailure(e?.response?.data?.message));
    dispatch(getBadgeAction.getBadgeSliceReset());
  }
};
export default getBadgeSlice.reducer;
export const getBadgeAction = getBadgeSlice.actions;
